import { Schema } from 'mongoose';

export interface IRating {
  average: number;
  count: number;
}

const ratingSchema = new Schema(
  {
    average: {
      type: Number,
      required: true,
      min: 0,
      max: 5,
      default: 0,
    },
    count: {
      type: Number,
      required: true,
      min: 0,
      default: 0,
    },
  },
  { _id: false },
);

export default ratingSchema;
